import React, { useMemo  } from 'react';

import './ValueCardBenefits.scss';

const ValueCardBenefits = ({benefit, selectedBenefits, onSelectedBenefits}) => {

    const isSelected= useMemo(() =>
                selectedBenefits
                .map((i) => i.promoId)
                .includes(benefit.promoId),
            [selectedBenefits, benefit]
          );

    return (
        <div
          className={`valuecard-benefit-item ${isSelected ? "selected" : ""}`}
          onClick={() => {
            onSelectedBenefits(benefit);
          }}
        >
          <div className="benefit-title-cell">{benefit.title}</div>
          <div className="benefit-description-cell">{benefit.description}</div>
        </div>
      );
    };
  
  export default ValueCardBenefits;
